import { getSessionStorage } from '@/shared/lib/storage';
import { isDebugEnabled } from '@/shared/lib/system';
import { useSessionStore } from './sessionStore';

/**
 * 現在ログイン中のユーザーが管理者ロールかどうかを判定する
 *
 * 返り値:
 *  - true  : admin
 *  - false : admin 以外（member / editor 等）
 *  - null  : セッション情報未取得（読み込み中）
 *
 * null の間はガード処理を保留することで、誤リダイレクト・メニューチラつきを防ぐ。
 *
 * デバッグメニューの「ロール上書き」が設定されている場合は、そちらの値を優先する。
 * （`isDebugEnabled()` が true のときのみ有効。プロダクションでは無視される）
 */
export const useIsAdmin = (): boolean | null => {
  const role = useSessionStore((state) => state.user?.role);

  // セッション読み込み中（null）は override より優先して保留状態を返す
  // override を先に評価すると、UserListPage 等の `isAdmin === false`/`=== true` 判定で
  // セッション確立前に 403 リダイレクトや認証前 API 呼び出しが走ってしまうため
  if (role == null) return null;

  if (isDebugEnabled()) {
    const override = getSessionStorage('debug-role-override');
    if (override === 'admin') return true;
    if (override === 'editor') return false;
  }

  return role === 'admin';
};
